import { render, staticRenderFns } from "./ExportTypeCurves.vue?vue&type=template&id=61274fab"
import script from "./ExportTypeCurves.vue?vue&type=script&lang=js"
export * from "./ExportTypeCurves.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports